import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { InviteScreen } from '../features/household/InviteScreen.tsx';

export const Route = createFileRoute('/invite/$token')({ component: InviteRoute });

function InviteRoute() {
  const { token } = Route.useParams();
  const navigate = useNavigate();
  return <InviteScreen token={token} onDone={() => void navigate({ to: '/recipes' })} />;
}
